<template>
	<BaseCard class="flex items-center gap-4">
		<ItemIcon :src="src" :name="title" :preloader="preloader || undefined" />
		<div class="min-w-0 flex-1">
			<div class="text-label-primary truncate text-sm font-medium capitalize">
				{{ title }}
			</div>
			<div class="text-label-secondary mt-1 truncate text-xs capitalize">
				{{ t('models', listings) }}
			</div>
		</div>
		<div class="inline-flex flex-col">
			<CoinPrice :price="price" />
			<div
				class="text-label-secondary mt-1 text-right text-xs font-medium uppercase"
			>
				{{ t('floor') }}
			</div>
		</div>
		<BaseCheckbox :modelValue="selected" />
	</BaseCard>
</template>
<script setup lang="ts">
import CoinPrice from './CoinPrice.vue'
import BaseCard from './BaseCard.vue'
import ItemIcon from './ItemIcon.vue'
import BaseCheckbox from './BaseCheckbox.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			models: '{n} model | {n} models',
			floor: 'floor'
		},
		ru: {
			models: '{n} моделей | {n} модель | {n} модели | {n} моделей',
			floor: 'мин. цена'
		}
	}
})

defineProps<{
	src: string
	title: string
	listings: number
	price: number
	selected?: boolean
	preloader?: string | null
}>()
</script>
